import React from "react";
import Components from "mpm-components";
import { Form } from "semantic-ui-react";
import { DateInput } from "semantic-ui-calendar-react";
import Utilities from "mpm-config/Utilities";

export default ({ cessionExport, entities, setCessionExport, editMode }) => {

  const onChangeData = (name, value) => {
      if(name === "numeroCertificat" &&  (name !== "" && !Utilities.isNumber(value))) return; 
      
      setCessionExport({...cessionExport, [name] : value})
  }


    return (
      <Components.Regions.RegionWithHeader
        title="menu.demande.export"
        headerColor="blue"
        headerSize="small"
      >
        <Form>
          <Form.Group widths="equal">
            <Form.Checkbox toggle 
            checked={cessionExport.certificatManuelle}  
            onChange={(e, { name, value }) => onChangeData("certificatManuelle", !cessionExport.certificatManuelle)}
            label="Choisir Demande SAP"
            />

            {
              cessionExport.certificatManuelle ? 
              <>
                  <DateInput
                    label={
                      <label>
                        Date Cértificat Exportation SAP<font color="red">*</font>
                      </label>
                    }
                    clearable
                    closable
                    type="text"
                    name="dateVisa"
                    icon="calendar"
                    iconPosition="right"
                    maxDate={new Date()}
                    value={cessionExport.dateVisa}
                    animation="fade"
                    autoComplete="off"
                    dateFormat="DD/MM/YYYY"
                    onChange={(e, { name, value }) => onChangeData("dateVisa", value)}
                  />
                <Form.Input
                  required
                  label="Numéro Cértificat Exportation SAP"
                  value={cessionExport.numeroCertificat} 
                  onChange={({target}) => onChangeData("numeroCertificat", target.value)}
                />
              </>
              :
              <>
                <Form.Field />
                <Form.Field />
              </>
            }


          </Form.Group>
          
          <Form.Group widths="equal">
            <Form.Input
              label="Référence Demande Exportation"
              value={cessionExport.numeroCessionComplet}
              disabled
            />
            <DateInput
                label="Date Système "
                value={cessionExport.dateSysteme}
                name="dateSysteme"
                icon="calendar"
                iconPosition="right"
                dateFormat="DD/MM/YYYY"
                disabled
              />
              <DateInput
                label="Date Demande Exportation"
                value={cessionExport.dateCession}
                name="dateCession"
                icon="calendar"
                iconPosition="right"
                dateFormat="DD/MM/YYYY"
                animation="fade"
                    autoComplete="off"
                    clearable
                    closable
                onChange={(e, { name, value }) => onChangeData("dateCession", value)}
              />
            
          </Form.Group>
          <Form.Group widths="equal">
            <Form.Select
                label="DPM De Validation"
                required
                options={entities.data}
                disabled={editMode}
                value={cessionExport.id_RefDpmValid}
                onChange={(e, { name, value }) => onChangeData("id_RefDpmValid", value)}
            />

            <Form.Field />
            <Form.Field />
         </Form.Group>
          
        </Form>
      </Components.Regions.RegionWithHeader>
    );
  };